export default class FetchTimeOut {
    constructor(props) {
        this.props = props;
        this.timerId = null;

        if (!this?.props?.timeout && parseInt(this?.props?.timeout) !== 0) {
            console.warn('Timeout is not provided, defaulting to 5000ms');
            this.props.timeout = 5000;
        } else {
            this.props.timeout = parseInt(this.props.timeout);
        }

        this.abort = new AbortController();

        this.props.options = {
            ...props.options,
            signal: this.abort.signal,
        }

    }

    promiseFetch() {
        return fetch(this.props.url, this?.props?.options)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error;
            });
    }

    promiseTimeout() {
        console.log(`promiseTimeout set to ${this.props.timeout}ms`);
        return new Promise((resolve, reject) => {
            this.timerId = setTimeout(() => {
                // let message = 'Fetch ';
                // message += this.props?.options ? `with options ${this.props.options} ` : '';
                // message += `from ${this.props.url} timed out after ${this.props.timeout}ms`;
                const message = `Service unavailable, please try again later`;
                this.abort.abort();
                clearTimeout(this.timerId);
                return reject(new Error(message));
            }, this.props.timeout);
        });
    }

    pull() {
        try {
            Promise.race([
                this.promiseFetch(),
                this.promiseTimeout()
            ])
                .then((response) => {
                    if (response.ok) {
                        const data = response.json();
                        return data;
                    } else {
                        throw new Error(response.statusText);
                    }
                })
                .then((data) => {
                    if (this.props?.successCallback) {
                        this.props.successCallback(data);
                    } else {
                        console.log(data);
                    }
                })
                .catch((error) => {
                    if (this.props?.failureCallback) {
                        this.props.failureCallback(error);
                    } else {
                        console.error(error);
                    }
                });
        } catch (error) {
            console.error(error);
            return error
        }
    }

}